import { defineStore } from "pinia";
import { ref } from "vue";

export const useConsentStore = defineStore("consent", () => {
  const termsOfUse = ref(false);
  const privacyPolicy = ref(false);
  const allowTracking = ref(false);

  return {
    termsOfUse,
    privacyPolicy,
    allowTracking,
  };
});
